import React, {PropTypes} from 'react';
import CalendarRecommendations from './CalendarRecommendations';
import CalendarTemperatures from './CalendarTemperatures';
import CalendarPrecipitations from './CalendarPrecipitations';
import Prices from '../containers/Prices';
import SelectionAdd from '../containers/SelectionAdd';

class Infobox extends React.Component {

  constructor () {
    super();
    this.resizeTables = this.resizeTables.bind(this);
  }

  componentDidMount () {
    // Modify the tables width when window is resized
    window.addEventListener('resize', this.resizeTables);
  }

  resizeTables () {
    let width = this.defineWidth();

    // Manage heights by directly manipulating them
    $('.infobox table').css('width', width + 'px');

    // The infobox container is centered on the map on large screens
    // But centered on the whole page for small screens
    if(this.screenIsLarge()){
      // Add the class if it does not have it already
      if (!$('.infobox-container').hasClass('large-screen')) {
        $('.infobox-container').addClass('large-screen');
      }
    }
    else{
      // Remove the class if it has it
      if ($('.infobox-container').hasClass('large-screen')) {
        $('.infobox-container').removeClass('large-screen');
      }
    }
  }

  screenIsLarge () {
    let output = false;
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let width = this.defineWidth();

    if (width < windowWidth * 0.55 && windowHeight > 640) {
      output = true;
    }
    return output;
  }

  defineWidth () {
    // find what is the rate of the current currency
    let rate = this.props.currencies.rates[this.props.userLocation.currency_code];

    let minimum = 550;
    let width = minimum;

    // Give space for high rates
    let rate_space = 0;
    if (rate > 5) rate_space = 50;
    if (rate > 20) rate_space = 100;
    if (rate > 50) rate_space = 120;
    if (rate > 100) rate_space = 200;
    if (rate > 500) rate_space = 250;
    if (rate > 1000) rate_space = 300;
    if (rate > 2000) rate_space = 350;
    if (rate > 5000) rate_space = 400;
    if (rate > 10000) rate_space = 450;

    width = width + rate_space;

    // if the width is less than half the screen
    let windowWidth = $(window).width();
    if (width < windowWidth * 0.49) {
      width = windowWidth * 0.49;
    }

    return width;
  }

  hidePromo() {
    this.props.selectionActions.hidePromo();
  }

  render() {
    let areas = this.props.data;
    let areaId = this.props.selection.infobox_area_id;
    let calendar_recommendations;
    let calendar_temperatures;
    let calendar_precipitations;
    let area_name;
    let country_name;
    let initialWidth = this.defineWidth() + 'px';

    // Hide the details popin if there is no selected area
    if(areaId == false) {
      // The container has a defined height. If we destroy it and re-create it, it would lose its calculated height.
      return (
        <div className="infobox-container hide" />
      );
    }

    area_name = areas[areaId]['name'];
    country_name = area_name.split(', ')[0];

    calendar_recommendations = (
      <div key={'r' + areaId}>
        <CalendarRecommendations
          recommended={areas[areaId]['recommended']}
          size="big"
          currentMonth={this.props.selection.currentMonth}
          initialWidth={initialWidth}
        />
      </div>
    );

    calendar_temperatures = (
      <div key={'t' + areaId}>
        <CalendarTemperatures
          temperatures={areas[areaId]['temperatures']}
          size="big"
          currentMonth={this.props.selection.currentMonth}
          initialWidth={initialWidth}
        />
      </div>
    );

    calendar_precipitations = (
      <div key={'p' + areaId}>
        <CalendarPrecipitations
          precipitations={areas[areaId]['precipitations']}
          size="big"
          currentMonth={this.props.selection.currentMonth}
          initialWidth={initialWidth}
        />
      </div>
    );

    let cssInfoboxContainer = 'infobox-container';
    if (this.screenIsLarge()) {
      cssInfoboxContainer += ' large-screen';
    }

    return (
      <div className={cssInfoboxContainer} >
        <div className="infobox">
          <div className="close-button" onClick={this.props.selectionActions.hideInfobox}>
            <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <g id="icon-close" fill="#FFFFFF">
                <polygon id="close" points="8.29289322 8.5 0.868272016 15.9246212 1.5753788 16.631728 9 9.20710678 16.4246212 16.631728 17.131728 15.9246212 9.70710678 8.5 17.131728 1.0753788 16.4246212 0.368272016 9 7.79289322 1.5753788 0.368272016 0.868272016 1.0753788 8.29289322 8.5" />
              </g>
            </svg>
          </div>

          <h4 className="title">
            { area_name }
            &nbsp; <SelectionAdd areaId={areaId} />
          </h4>

          { calendar_recommendations }

          <div className="tabs-container">
            <ul className="nav nav-tabs" role="tablist">
              <li role="presentation" className="active">
                <a href="#metrics" aria-controls="metrics" role="tab" data-toggle="tab">
                  <span className="hidden-xs">Weather charts</span>
                  <span className="hidden-sm hidden-md hidden-lg">Charts</span>
                </a>
              </li>
              <li role="presentation">
                <a href="#prices" aria-controls="prices" role="tab" data-toggle="tab" onClick={this.hidePromo.bind(this)}>
                  Flights to {country_name} <span className="badge new">New</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="metrics">
              { calendar_temperatures }
              { calendar_precipitations }
            </div>
            <div role="tabpanel" className="tab-pane" id="prices">
              <Prices
                initialWidth={initialWidth}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Infobox.propTypes = {
  data: PropTypes.object.isRequired,
  selection: PropTypes.object.isRequired,
  selectionActions: PropTypes.object.isRequired,
  currencies: PropTypes.object.isRequired,
  userLocation: PropTypes.object.isRequired
};

export default Infobox;



/** WEBPACK FOOTER **
 ** ./src/components/Infobox.js
 **/